import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Alert } from 'reactstrap'
import AutoTable from 'components/AutoTable'
import { SiteColContainer } from './SitesGrid.styles'
import { IsRosteredBadge } from 'components/IsRosteredBadge/IsRosteredBadge'

interface SiteRow {
  id: number
  name: string
  isRostered: boolean
  organizationId: number
}

interface SitesGridProps {
  licenses: SiteRow[]
}

interface SitesGridState {
  isLoading: boolean
  confirmShow: boolean
  onConfirm: (() => void) | null
  confirmTitle: string
  confirmBody: React.ReactNode | null
}

class SitesGrid extends Component<SitesGridProps, SitesGridState> {
  constructor(props: SitesGridProps) {
    super(props)
    this.state = {
      isLoading: false,
      confirmShow: false,
      onConfirm: null,
      confirmTitle: '',
      confirmBody: null,
    }
  }

  columns = [
    {
      title: 'Site Name',
      fieldValue: 'name' as const,
    },
    {
      title: 'Site Id',
      fieldValue: (row: SiteRow) => {
        return (
          <SiteColContainer>
            <Link to={`/css-admin/sites/${row.id}`}>{row.id}</Link>
            <IsRosteredBadge isRostered={row.isRostered} summaryView={false} />
          </SiteColContainer>
        )
      },
      sortValue: 'id' as const,
      filterValue: 'id' as const,
    },
    {
      title: 'Organization Id',
      fieldValue: 'organizationId' as const,
    },
  ]

  render = () => {
    const { licenses } = this.props

    return licenses && licenses.length ? (
      <AutoTable
        borderless
        columns={this.columns}
        filter
        headThemeLight
        rows={licenses}
        sort
      />
    ) : (
      <Alert color="warning">No results found</Alert>
    )
  }
}

export default SitesGrid
